//GeneratorFlag:[NoChange]
import routes from './routes'
import services from './services'
import resources from './resources'
import toolbar from './toolbar'

const hub = {
	name: 'hub',
	foldreName: 'hub',
	routes,
	services,
	resources,
	toolbar
}

export default hub
export { routes, services, resources, toolbar }